import React, { Fragment } from 'react';
// import { useHistory, useParams, useLocation  } from 'react-router-dom'

const LogoutSAML = props => {
   
    return (
        <Fragment>
            <p>Your previous GatorLink Shibboleth session was not ended.</p>
            <p>To completely end your session you MUST CLOSE this Browser.</p>    
            <p>For best security practice you should close your browser if you are leaving this computer.</p>
            <p>Unattended GatorLink sessions are a security risk and should be avoided.</p>

           
        </Fragment >
    );

}
export default LogoutSAML;
